let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d7APn")).then(() => parcelRequire('1RvFs'));